// @ts-nocheck
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';

const ServiceFormSkeleton = ({ id, ...rest }) => {
  return (
    <Box
      id={id}
      data-testid='accommodation-form-skeleton'
      display='flex'
      flexDirection='column'
      gap={3}
      padding={3}
      border='1px solid #EAECF0'
      borderRadius='8px'
      backgroundColor='#FFFFFF'
      {...rest}
    >
      <Skeleton variant='text' width='30%' height={32} />
      <Skeleton variant='text' width='50%' height={40} />

      <Skeleton variant='rectangular' width='100%' height={120} />

      <Box display='flex' gap={2}>
        <Skeleton variant='text' width='33%' height={40} />
        <Skeleton variant='text' width='33%' height={40} />
        <Skeleton variant='text' width='33%' height={40} />
      </Box>

      <Box display='flex' gap={2}>
        <Skeleton variant='text' width='20%' height={40} />
        <Skeleton variant='text' width='20%' height={40} />
        <Skeleton variant='text' width='15%' height={40} />
        <Skeleton variant='text' width='20%' height={40} />
        <Skeleton variant='text' width='25%' height={40} />
      </Box>

      <Box display='flex' gap={2}>
        <Skeleton variant='text' width='50%' height={40} />
        <Skeleton variant='text' width='50%' height={40} />
      </Box>

      <Box display='flex' gap={2}>
        <Skeleton variant='rectangular' width={100} height={100} />
        <Skeleton variant='rectangular' width={100} height={100} />
      </Box>

      <Skeleton variant='text' width='100%' height={60} />

      <Box display='flex' justifyContent='flex-end' gap={2}>
        <Skeleton variant='rectangular' width={100} height={36} />
        <Skeleton variant='rectangular' width={100} height={36} />
      </Box>
    </Box>
  );
};

ServiceFormSkeleton.propTypes = {
  id: PropTypes.string
};

export default ServiceFormSkeleton;
